module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v("\n        Products\n        "), _c('span', {
    staticClass: "dark fs-small"
  }, [_c('span', {
    staticClass: "pointer hoverLink ml-2",
    on: {
      "click": function($event) {
        return _vm.deselectAll()
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "pointer hoverLink",
    on: {
      "click": function($event) {
        return _vm.selectAll()
      }
    }
  }, [_vm._v("None")])])]), _vm._v(" "), _vm._l((_vm.filteredProducts), function(product) {
    return _c('div', {
      staticClass: "mb-2"
    }, [_c('div', {
      staticClass: "productRow d-flex align-items-center pointer",
      class: {
        'selected': _vm.isThisProductSelected(product)
      },
      on: {
        "click": function($event) {
          return _vm.blacklistProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "square mr-2",
      style: ({
        'background-color': _vm.selectProductColor(product).areaBackground,
        'border-color': _vm.selectProductColor(product).areaBorder
      })
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(product.name))])])])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f4bf3758", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4bf3758"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/filters/productFilterV2.vue
// module id = 2683
// module chunks = 0